import {
  Component,
  OnInit,
  Inject,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
} from '@angular/forms';
import { ProjectDto, GMOUDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'mrsoftapps-project-modal',
  templateUrl: './project-modal.component.html',
  styleUrls: ['./project-modal.component.css'],
})
export class ProjectModalComponent implements OnInit {
  projectActivityForm: FormGroup;
  projectPaymentForm: FormGroup;
  projectReportHistoryForm: FormGroup;
  projectReportActivityForm: FormGroup;
  projectReportMeetingForm: FormGroup;
  project: ProjectDto;

  selectedProjectActivity: any;
  selectedProjectPayment: any;

  filteredDelete: Array<any> = [];
  selectOptionForm: FormGroup;
  selectedProject: ProjectDto;
  selectedMonitorProject: ProjectDto[];
  selectedGmous: GMOUDto;
  stream = new BehaviorSubject(this.selectedProject);
  selectedProjects = this.stream.asObservable();
  filteredProject: ProjectDto;
  projectStatus = false;
  addProjectStatus = false;
  autoTicks = false;
  disabled = false;
  invert = false;
  max = 100;
  min = 0;
  showTicks = false;
  step = 1;
  thumbLabel = true;
  value = 0;
  vertical = false;
  tickInterval = 1;
  percentageValue: any;
  loggedInName = 'Elvis';
  uuId: string;

  totalProjectActivityProgress: any;
  selectedProjectType: any;
  selectedProjectActivities: any;
  constructor(
    public dialogRef: MatDialogRef<ProjectModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.uuId = uuid();
    if (this.modalData.name === 'createProjectActivity') {
      this.project = this.modalData.project;
      this.projectActivityForm = this.fb.group({
        ProjectActivities: this.fb.array([]),
      });
      this.selectGMOU();
    } else if (this.modalData.name === 'createProjectPayment') {
      this.project = this.modalData.project;
      this.projectValidatePaymentForm();
    } else if (this.modalData.name === 'selectOptions') {
      this.selectFormValidate();
    } else if (this.modalData.name === 'createProjectHistory') {
      this.projectReportActivityForm = this.fb.group({
        ProgressActivities: this.fb.array([]),
      });
      this.progressReportMasterValidationForm();
      this.setProgressReportActivity();
    } else if (this.modalData.name === 'createProjectMeeting') {
      this.progressReportMeetingValidationForm();
    } else if (this.modalData.name === 'viewProjectMeeting') {
    } else if (this.modalData.name === 'viewProjectMaster') {
      const sum = this.modalData.selectedReportHistories
        .map((item) => item.ProjectActivityProgress)
        .reduce((prev, next) => prev + next);
      this.totalProjectActivityProgress = Math.floor((sum / 100) * 100);
    } else if (this.modalData.name === 'viewBudgetPayment') {
    }
  }

  getSliderTickInterval(value, index) {
    this.projectReportActivityForm
      .get('ProgressActivities')
      ['controls'][index].controls['ProjectActivityReport'].setValue(value);
  }

  projectValidatePaymentForm() {
    this.projectPaymentForm = this.fb.group({
      Amount: ['', Validators.required],
      InvoiceNo: ['', Validators.required],
      PaymentDate: ['', Validators.required],
      PaymentDescription: ['', Validators.required],
      CurrencyId: ['', Validators.required],
      BeneficiaryId: ['', Validators.required],
      ProjectId: [this.modalData.selectedProject.id],
    });
  }

  getCurrencyName(id: string) {
    const foundCurrency = this.modalData.currencies.find(
      (item) => item.id.toLowerCase() === id.toLowerCase()
    );
    return foundCurrency && foundCurrency.CurrencyCode;
  }

  getBankName(id: string) {
    const foundBank = this.modalData.banks.find(
      (item) => item.id.toLowerCase() === id.toLowerCase()
    );
    return foundBank && foundBank.BankName;
  }

  progressReportMasterValidationForm() {
    this.projectReportHistoryForm = this.fb.group({
      ReportTitle: ['', Validators.required],
      ProgressReportDescription: ['', Validators.required],
      DateReported: [new Date()],
      ProjectId: this.modalData.selectedProject.id,
      ReportedBy: [this.loggedInName],
      ProgressReportTie: this.uuId,
    });
  }

  progressReportMeetingValidationForm() {
    this.projectReportMeetingForm = this.fb.group({
      MeetingReportTitle: ['', Validators.required],
      MeetingReportDescription: ['', Validators.required],
      ProjectId: this.modalData.selectedProject.id,
      ReportedBy: [this.loggedInName],
    });
  }

  selectFormValidate() {
    this.selectOptionForm = this.fb.group({
      GMOUTypeId: [''],
      GMOUId: [''],
      ProjectId: [''],
    });
  }

  selectGMOU() {
    this.selectedProject = this.modalData.projects.filter(
      (item) => item.GMOUId === this.modalData.gmous.id
    );
    this.stream.next(this.selectedProject);
  }

  selectProjectType(event) {
    this.selectedProjectType = event.value;
    this.selectedGmous = this.modalData.gmous.filter(
      (item) => item.GMOUTypeId === event.value
    );
  }

  selectProjectMonitorGMOU(id: string) {
    this.selectedMonitorProject = this.modalData.projects.filter(
      (item) => item.GMOUId === id
    );
  }

  filterProjectMonitor(id) {
    this.dialogRef.close(id);
  }

  selectProjectGMOUReport(id) {
    let data = {
      projectTypeId: this.selectedProjectType,
      gmouId: id,
    };
    this.dialogRef.close(data);
  }

  selectProject(value) {
    this.filteredProject = value;
    this.selectedProjectActivities = this.modalData.projectActivities.filter(
      (item) => item.ProjectId.toLowerCase() === value.id.toLowerCase()
    );
    const control = this.projectActivityForm.controls
      .ProjectActivities as FormArray;
    if (this.selectedProjectActivities.length > 0) {
      this.projectStatus = true;
      this.addProjectStatus = false;
      this.clearFormArray(control);
      this.setProjectActivity();
    } else {
      this.projectStatus = true;
      this.addProjectStatus = false;
      this.clearFormArray(control);
    }
  }

  clearFormArray = (formArray: FormArray) => {
    const control = this.projectActivityForm.controls
      .ProjectActivities as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.projectActivityForm.controls[control].hasError(error);
  };

  /* Handle form errors in Angular 8 */
  public errorPaymentHandling = (control: string, error: string) => {
    return this.projectPaymentForm.controls[control].hasError(error);
  };

  /* Handle form errors in Angular 8 */
  public errorHistoryHandling = (control: string, error: string) => {
    return this.projectReportHistoryForm.controls[control].hasError(error);
  };

  /* Handle form errors in Angular 8 */
  public errorMeetingHandling = (control: string, error: string) => {
    return this.projectReportMeetingForm.controls[control].hasError(error);
  };

  openProjectActivity() {
    this.dialogRef.close('createProjectActivity');
  }

  // If the user clicks the cancel button a.k.a. the go back button, then\
  // just close the modal
  closeModal() {
    this.dialogRef.close();
  }

  // method to display banks
  setProgressReportActivity() {
    const control = this.projectReportActivityForm.controls
      .ProgressActivities as FormArray;
    this.modalData.selectedProject.projectActivities.forEach((item) => {
      control.push(
        this.fb.group({
          ProjectActivityName: item.ProjectActivityName,
          ProjectActivityProgress: [0],
          ProjectActivityReport: [0],
          ProjectActivityDescription: item.ProjectActivityDescription,
          ProjectId: item.ProjectId,
          dateCreated: item.dateCreated,
          ProjectActivityId: item.id,
          ReportNote: [''],
          ProgressReportTie: this.uuId,
        })
      );
    });
  }

  // method to display banks
  setProjectActivity() {
    const control = this.projectActivityForm.controls
      .ProjectActivities as FormArray;
    this.selectedProjectActivities.forEach((item) => {
      control.push(
        this.fb.group({
          ProjectActivityName: item.ProjectActivityName,
          ProjectActivityDescription: item.ProjectActivityDescription,
          ProjectId: item.ProjectId,
          dateCreated: item.dateCreated,
          id: item.id,
        })
      );
    });
  }

  addProjectActivity() {
    const control = this.projectActivityForm.controls
      .ProjectActivities as FormArray;
    control.insert(
      0,
      this.fb.group({
        ProjectActivityName: [''],
        ProjectActivityDescription: [''],
        ProjectId: [this.filteredProject.id],
      })
    );
  }

  print(event: any) {
    window.print();
  }

  // method to delete bank from arrary list
  deleteProjectActivity(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.projectActivityForm.controls
          .ProjectActivities as FormArray;
        control.removeAt(index);

        if (value.id !== null) {
          // let deleteData = {
          //   ProjectId: this.filteredProject.projectActivities[i].ProjectId,
          //   id: this.filteredProject.projectActivities[i].id
          // }
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  openBankDetail() {
    this.dialogRef.close('bankDetail');
  }

  onSubmitReportMeeting(formData) {
    const newReportMeetingObject = [];
    newReportMeetingObject.push(formData);

    this.dialogRef.close(newReportMeetingObject);
  }

  onSubmitReportHistory() {
    if (!this.projectReportHistoryForm.valid) {
      return;
    }
    let newReportMasterObject = [];
    newReportMasterObject.push(this.projectReportHistoryForm.value);
    let data = {
      HistoryReport: this.projectReportActivityForm.value.ProgressActivities,
      MasterReport: newReportMasterObject,
    };

    this.dialogRef.close(data);
  }

  onSubmit(formValue) {
    let newObject = [];

    newObject.push(formValue);

    this.dialogRef.close(newObject);
  }

  onSubmitProjectActivity(form: any) {
    // this.filteredProject = Object.assign({}, this.filteredProject, {
    //   projectActivities: form.ProjectActivities
    // });

    let data = {
      formValue: null,
      filteredDelete: null,
      type: null,
    };
    if (this.filteredDelete.length !== 0) {
      data.filteredDelete = this.filteredDelete;
    }

    (data.formValue = form), (data.type = 'save');
    this.dialogRef.close(data);
  }
}
